module.exports = __webpack_public_path__ + "img/hoimg4.6cbdb071.png";